// // // import React, { useState, useEffect } from 'react';
// // // import './Emailestimate.css';
// // // import imglogo from '../../Images/acvl logo white.png';
// // // import { useParams } from 'react-router-dom';

// // // const EstimatePage = () => {
// // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const { id } = useParams();
// // //   const [termsHtml, setTermsHtml] = useState('');

// // //   useEffect(() => {
//     // const fetchEstimate = async () => {
//     //   try {
//     //     const response = await fetch('https://salesjet-10097049716.catalystappsail.com/estimate');
//     //     const apiResponse = await response.json();
//     //     const bookingsData = apiResponse.data;
//     //     if (!bookingsData || !Array.isArray(bookingsData)) {
//     //       throw new Error('Invalid or missing data in API response');
//     //     }
//     //     if (id) {
//     //       const booking = bookingsData.find(
//     //         (b) => String(b.LeadACVLRecordID).trim() === String(id).trim()
//     //       );
//     //       setSelectedBooking(booking || null);
//     //     } else {
//     //       setSelectedBooking(bookingsData[0]);
//     //     }
//     //     setLoading(false);
//     //   } catch (err) {
//     //     setError('Failed to fetch estimate data: ' + err.message);
//     //     setLoading(false);
//     //   }
//     // };
  
// // //     const fetchTermsHtml = async () => {
// // //       try {
// // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
// // //         const data = await response.json();
// // //         const records = data.records || [];
// // //         const viewEstimateRaw = records[0]?.["ViewEstimate "] || '';
// // //         const decodedHtml = viewEstimateRaw.replace(/\\u003C/g, '<').replace(/\\u003E/g, '>');
// // //         setTermsHtml(decodedHtml);
// // //       } catch (err) {
// // //         console.error('Failed to fetch terms HTML:', err);
// // //       }
// // //     };
  
// // //     fetchEstimate();
// // //     fetchTermsHtml();
// // //   }, [id]);
  
// // //   const parseItems = (itemsString) => {
// // //     try {
// // //       const cleanedString = (itemsString || '[]').replace(/[\[\]]/g, '');
// // //       const itemsArray = cleanedString.split('},').map(item => {
// // //         if (!item.endsWith('}')) item += '}';
// // //         const descMatch = item.match(/desc=([^,}]*)/);
// // //         const prodMatch = item.match(/prod=([^,}]*)/);
// // //         const rateMatch = item.match(/rate=([^,}]*)/);
// // //         const qtyMatch = item.match(/qty=([^,}]*)/);
  
// // //         const desc = descMatch ? descMatch[1].trim() : 'Service Charge';
// // //         const prod = prodMatch ? prodMatch[1].trim() : '';
// // //         const rate = parseFloat(rateMatch ? rateMatch[1].trim() : '0.00');
// // //         const qty = parseInt(qtyMatch ? qtyMatch[1].trim() : '1');
// // //         const amount = (rate * qty).toFixed(2);
  
// // //         return { desc, prod, rate: rate.toFixed(2), qty, amount };
// // //       });
  
// // //       return itemsArray;
// // //     } catch (e) {
// // //       return [{ desc: 'Service Charge', prod: '', rate: '0.00', qty: 1, amount: '0.00' }];
// // //     }
// // //   };
// // //   if (loading) return <div>Loading...</div>;
// // //   if (error) return <div>{error}</div>;
// // //   if (!selectedBooking) return <div>No matching estimate found for ID: {id || 'N/A'}</div>;

// // //   const data = {
// // //     today: new Date(selectedBooking.CREATEDTIME).toLocaleDateString('en-US', {
// // //       day: '2-digit',
// // //       month: '2-digit',
// // //       year: 'numeric'
// // //     }),
// // //     originCity: selectedBooking.FromAddress || 'N/A',
// // //     originProvince: selectedBooking.FromAddress
// // //       ? (selectedBooking.FromAddress.split(',')[2]?.trim() || 'N/A')
// // //       : 'N/A',
// // //     destinationCity: selectedBooking.ToAddress || 'N/A',
// // //     destinationProvince: selectedBooking.ToAddress
// // //       ? (selectedBooking.ToAddress.split(',')[2]?.trim() || 'N/A')
// // //       : 'N/A',
// // //     duration: 'N/A',
// // //     customerName: selectedBooking.Customer_Name || 'N/A',
// // //     SalesAgent: selectedBooking.Sales_Agent || 'N/A',
// // //     MoveDate: selectedBooking.Move_Date || 'N/A',
// // //     moveSize: selectedBooking.Move_Size || 'N/A',
// // //     TaxV: parseFloat(selectedBooking.TAXValue) || 0.00,
// // //     TaxP: selectedBooking.TaxPercentage || '0.00',
// // //     Discount: parseFloat(selectedBooking.Discount) || 0.00,
// // //     discountType: selectedBooking.DiscountType || 'percent',
// // //     items: parseItems(selectedBooking.Items),
// // //     Deposittopay: parseFloat(selectedBooking.Deposittopay) || 0.00,
// // //     Estimatetotal: parseFloat(selectedBooking.Estimatetotal) || 0.00,
// // //     subTotal: parseFloat(selectedBooking.Subtotal) || 0.00
// // //   };

// // //   const discountAmount = data.discountType === 'percent' 
// // //   ? (data.subTotal * (data.Discount / 100)).toFixed(2)
// // //   : data.Discount.toFixed(2);
  
// // //   return (
// // //     <div className='main-page'>
// // //       <div className='inner-page'>
// // //         <div className="header">
// // //           <div>
// // //             <div className='img-main-class' style={{ backgroundColor: '#f8f8f8' }}>
// // //               <div className='img-cls'></div>
// // //               <div className='img-cls'>
// // //                 <img src={imglogo} alt="ACVL Logo" className='logo-cls' />
// // //               </div>
// // //             </div>
// // //             <div className="light-gray-bar"></div>
// // //             <div className="dark-gray-bg"></div>
// // //             <div className="dark-gray-bar"></div>
// // //             <div className="red-bar"></div>
// // //             <div className="blue-bar"></div>
// // //             <div className="white-stripe"></div>
// // //             <div className="small-red-dot"></div>
// // //             <div className="redd-bar"></div>
// // //             <div className="header-padd">
// // //               <table style={{ padding: '0px 20px' }}>
// // //                 <tr>
// // //                   <th className="heading_h">Estimate</th>
// // //                 </tr>
// // //                 <tr>
// // //                   <th className="date_h">{data.today} / Est.No {selectedBooking.LeadACVLRecordID}</th>
// // //                 </tr>
// // //               </table>
// // //             </div>
// // //           </div>
// // //           <div className="t_body" style={{ padding: '0px 20px' }}>
// // //             <div className="t_body" style={{ width: '100%' }}>
// // //               <table className="first_body cust_table">
// // //                 <tr>
// // //                   <th>Origin Address</th>
// // //                   <th>Destination Address</th>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>{data.originCity}</td>
// // //                   <td>{data.destinationCity}</td>
// // //                 </tr>
// // //                 <tr>
// // //                   <th>Customer Name</th>
// // //                   <th>Sales Agent</th>
// // //                   <th>Move Date</th>
// // //                   <th>Move Size</th>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>{data.customerName}</td>
// // //                   <td>{data.SalesAgent}</td>
// // //                   <td>{data.MoveDate}</td>
// // //                   <td>{data.moveSize}</td>
// // //                 </tr>
// // //               </table>
// // //             </div>
// // //             <div>
// // //               <table className="item_table itm_tab_padd" style={{ width: '100%' }}>
// // //                 <thead>
// // //                   <tr>
// // //                     <th style={{ borderBottom: '3px solid #B4B4D0' , textAlign: 'left'}}>S.No</th>
// // //                     <th style={{ borderBottom: '3px solid #B4B4D0' , textAlign: 'left'}}>Services / Products</th>
// // //                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>Price</th>
// // //                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>Quantity</th>
// // //                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>Amount</th>
// // //                   </tr>
// // //                 </thead>
// // //                 <tbody>
// // //                   {data.items.map((item, index) => (
// // //                     <tr key={index}>
// // //                       <td>{index + 1}</td>
// // //                       <td>
// // //                         <div>{item.desc}</div> 
// // //                         <div style={{ fontSize: '0.85em', color: '#555' }}>{item.prod}</div>
// // //                       </td>
// // //                       <td style={{ textAlign: 'right' }}>${item.rate}</td>
// // //                       <td style={{ textAlign: 'right' }}>{item.qty}</td>
// // //                       <td style={{ textAlign: 'right' }}>${item.amount}</td>
// // //                     </tr>
// // //                   ))}
// // //                 </tbody>
// // //               </table>
// // //             </div>
// // //             <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
// // //               <table className='item_table itm_tab_padd totals-table' style={{ width: '300px' }}>
// // //                 <tbody>
// // //                   <tr>
// // //                     <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
// // //                       <strong>Sub Total:</strong><span style={{ marginLeft: '15px' }}>${data.subTotal.toFixed(2)}</span>
// // //                     </td>
// // //                   </tr>
// // //                   {data.Discount > 0 && (
// // //                     <tr>
// // //                       <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
// // //                         <strong>Discount{data.discountType === 'percent' ? ` (${data.Discount}%)` : ''}:</strong>
// // //                         <span style={{ marginLeft: '15px' }}>${discountAmount}</span>
// // //                       </td>
// // //                     </tr>
// // //                   )}
// // //                   <tr>
// // //                     <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
// // //                       <strong>Tax ({data.TaxP}):</strong><span style={{ marginLeft: '15px' }}>${data.TaxV.toFixed(2)}</span>
// // //                     </td>
// // //                   </tr>
// // //                   <tr>
// // //                     <td style={{ padding: '8px', borderBottom: '1px solid #B4B4D0' }}>
// // //                       <strong>Total:</strong><span style={{ marginLeft: '15px' }}>${data.Estimatetotal.toFixed(2)}</span>
// // //                     </td>
// // //                   </tr>
// // //                   <tr>
// // //                     <td style={{ padding: '8px', borderBottom: '3px solid #B4B4D0' }}>
// // //                       <strong>Deposit to Pay:</strong><span style={{ marginLeft: '15px' }}>${data.Deposittopay.toFixed(2)}</span>
// // //                     </td>
// // //                   </tr>
// // //                 </tbody>
// // //               </table>
// // //             </div>
// // //             <div dangerouslySetInnerHTML={{ __html: termsHtml }} />

// // //             {/* <div>
// // //               <table className="table_padding remove_border">
// // //                 <tr>
// // //                   <td style={{ color: '#1D3352' }}><b>Comments</b></td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>
// // //                     <p>Thank you for choosing All Canada Van Lines Inc. This estimate is based on the information provided. Please notify us if you wish to include or exclude any services or accessories.</p>
// // //                   </td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td style={{ color: '#1D3352' }}><b>Terms and Conditions</b></td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>
// // //                     <p>1. Non-refundable fees are required at the time of booking for both local and long-distance moves.</p>
// // //                     <span>2. Full payment must be completed before final unloading. For long-distance moves, payment is required a day before delivery to avoid issues.</span>
// // //                   </td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td style={{ color: '#1D3352' }}><b>Insurance Coverage:</b></td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>
// // //                     <p>1. Basic Insurance covers .60 cents per pound.</p>
// // //                   </td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td style={{ color: '#1D3352' }}><b>Additional Charges</b></td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>
// // //                     <div className='trms-padd'>1. Staircase Fee: $150.00 for each set of 10 stairs.</div>
// // //                     <div className='trms-padd'>2. Heavy Objects: Additional charges for items like pianos, pool tables, oversized sofas, or large appliances.</div>
// // //                     <div className='trms-padd'>3. Long Walk Fee: $300.00 for every 4 hours (with 2 movers) if the walk from the truck to the customer's place exceeds 50 feet.</div>
// // //                     <div className='trms-padd'>4. If a ferry is involved, there will be a fee.</div>
// // //                   </td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>
// // //                     <b style={{ color: '#1D3352' }}>Delivery Time</b>: Varies based on weather conditions and province, ranging from 2 to 15 working days.
// // //                   </td>
// // //                 </tr>
// // //                 <tr>
// // //                   <td>
// // //                     <b style={{ color: '#1D3352' }}>Valuables</b>: We do not transport jewelry, documents, or other valuables. Proper documentation is required if we must carry them.
// // //                   </td>
// // //                 </tr>
// // //               </table>
// // //             </div> */}
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default EstimatePage;

// // // before LeadId decoding

// import React, { useState, useEffect } from 'react';
// import './Emailestimate.css';
// import imglogo from '../../Images/acvl logo white.png';
// import { useParams } from 'react-router-dom';

// const EstimatePage = () => {
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { id } = useParams();
//   const [termsHtml, setTermsHtml] = useState('');

// let decodedId = id || '';
//   if (id) {
//     try {
//       const potentialDecoded = atob(id);
//       if (potentialDecoded && !isNaN(potentialDecoded)) {
//         decodedId = potentialDecoded;
//       }
//     } catch (e) {
//       decodedId = id;
//     }
//   }

//   useEffect(() => {
//     const fetchEstimate = async () => {
//       if (error) return;
//       try {
//         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/estimate');
//         const apiResponse = await response.json();
//         const bookingsData = apiResponse.data;
//         if (!bookingsData || !Array.isArray(bookingsData)) {
//           throw new Error('Invalid or missing data in API response');
//         }
//         if (decodedId) {
//           const booking = bookingsData.find(
//             (b) => String(b.LeadACVLRecordID).trim() === String(decodedId).trim()
//           );
//           setSelectedBooking(booking || null);
//         } else {
//           setSelectedBooking(bookingsData[0]);
//         }
//         setLoading(false);
//       } catch (err) {
//         setError('Failed to fetch estimate data: ' + err.message);
//         setLoading(false);
//       }
//     };

//     const fetchTermsHtml = async () => {
//       try {
//         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
//         const data = await response.json();
//         const records = data.records || [];
//         const viewEstimateRaw = records[0]?.["ViewEstimate "] || '';
//         const decodedHtml = viewEstimateRaw.replace(/\\u003C/g, '<').replace(/\\u003E/g, '>');
//         setTermsHtml(decodedHtml);
//       } catch (err) {
//         console.error('Failed to fetch terms HTML:', err);
//       }
//     };

//     fetchEstimate();
//     fetchTermsHtml();
//   }, [decodedId, error]);

//   const parseItems = (itemsString) => {
//     try {
//       const cleanedString = (itemsString || '[]').replace(/[\[\]]/g, '');
//       const itemsArray = cleanedString.split('},').map(item => {
//         if (!item.endsWith('}')) item += '}';
//         const descMatch = item.match(/desc=([^,}]*)/);
//         const prodMatch = item.match(/prod=([^,}]*)/);
//         const rateMatch = item.match(/rate=([^,}]*)/);
//         const qtyMatch = item.match(/qty=([^,}]*)/);

//         const desc = descMatch ? descMatch[1].trim() : 'Service Charge';
//         const prod = prodMatch ? prodMatch[1].trim() : '';
//         const rate = parseFloat(rateMatch ? rateMatch[1].trim() : '0.00');
//         const qty = parseInt(qtyMatch ? qtyMatch[1].trim() : '1');
//         const amount = (rate * qty).toFixed(2);

//         return { desc, prod, rate: rate.toFixed(2), qty, amount };
//       });

//       return itemsArray;
//     } catch (e) {
//       return [{ desc: 'Service Charge', prod: '', rate: '0.00', qty: 1, amount: '0.00' }];
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>{error}</div>;
//   if (!selectedBooking) return <div>No matching estimate found for ID: {decodedId || 'N/A'}</div>;

//   const data = {
//     today: new Date(selectedBooking.CREATEDTIME).toLocaleDateString('en-US', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//     }),
//     originCity: selectedBooking.FromAddress || 'N/A',
//     originProvince: selectedBooking.FromAddress
//       ? (selectedBooking.FromAddress.split(',')[2]?.trim() || 'N/A')
//       : 'N/A',
//     destinationCity: selectedBooking.ToAddress || 'N/A',
//     destinationProvince: selectedBooking.ToAddress
//       ? (selectedBooking.ToAddress.split(',')[2]?.trim() || 'N/A')
//       : 'N/A',
//     duration: 'N/A',
//     customerName: selectedBooking.Customer_Name || 'N/A',
//     SalesAgent: selectedBooking.Sales_Agent || 'N/A',
//     MoveDate: selectedBooking.Move_Date || 'N/A',
//     moveSize: selectedBooking.Move_Size || 'N/A',
//     TaxV: parseFloat(selectedBooking.TAXValue) || 0.00,
//     TaxP: selectedBooking.TaxPercentage || '0.00',
//     Discount: parseFloat(selectedBooking.Discount) || 0.00,
//     discountType: selectedBooking.DiscountType || 'percent',
//     items: parseItems(selectedBooking.Items),
//     Deposittopay: parseFloat(selectedBooking.Deposittopay) || 0.00,
//     Estimatetotal: parseFloat(selectedBooking.Estimatetotal) || 0.00,
//     subTotal: parseFloat(selectedBooking.Subtotal) || 0.00,
//   };

//   const discountAmount =
//     data.discountType === 'percent'
//       ? (data.subTotal * (data.Discount / 100)).toFixed(2)
//       : data.Discount.toFixed(2);

//   return (
//     <div className="main-page">
//       <div className="inner-page">
//         <div className="header">
//           <div>
//             <div className="img-main-class" style={{ backgroundColor: '#f8f8f8' }}>
//               <div className="img-cls"></div>
//               <div className="img-cls">
//                 <img src={imglogo} alt="ACVL Logo" className="logo-cls" />
//               </div>
//             </div>
//             <div className="light-gray-bar"></div>
//             <div className="dark-gray-bg"></div>
//             <div className="dark-gray-bar"></div>
//             <div className="red-bar"></div>
//             <div className="blue-bar"></div>
//             <div className="white-stripe"></div>
//             <div className="small-red-dot"></div>
//             <div className="redd-bar"></div>
//             <div className="header-padd">
//               <table style={{ padding: '0px 20px' }}>
//                 <tr>
//                   <th className="heading_h">Estimate</th>
//                 </tr>
//                 <tr>
//                   <th className="date_h">
//                     {data.today} / Est.No {decodedId || selectedBooking.LeadACVLRecordID}
//                   </th>
//                 </tr>
//               </table>
//             </div>
//           </div>
//           <div className="t_body" style={{ padding: '0px 20px' }}>
//             <div className="t_body" style={{ width: '100%' }}>
//               <table className="first_body cust_table">
//                 <tr>
//                   <th>Origin Address</th>
//                   <th>Destination Address</th>
//                 </tr>
//                 <tr>
//                   <td>{data.originCity}</td>
//                   <td>{data.destinationCity}</td>
//                 </tr>
//                 <tr>
//                   <th>Customer Name</th>
//                   <th>Sales Agent</th>
//                   <th>Move Date</th>
//                   <th>Move Size</th>
//                 </tr>
//                 <tr>
//                   <td>{data.customerName}</td>
//                   <td>{data.SalesAgent}</td>
//                   <td>{data.MoveDate}</td>
//                   <td>{data.moveSize}</td>
//                 </tr>
//               </table>
//             </div>
//             <div>
//               <table className="item_table itm_tab_padd" style={{ width: '100%' }}>
//                 <thead>
//                   <tr>
//                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'left' }}>S.No</th>
//                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'left' }}>
//                       Services / Products
//                     </th>
//                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>Price</th>
//                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>
//                       Quantity
//                     </th>
//                     <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>
//                       Amount
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.items.map((item, index) => (
//                     <tr key={index}>
//                       <td>{index + 1}</td>
//                       <td>
//                         <div>{item.desc}</div>
//                         <div style={{ fontSize: '0.85em', color: '#555' }}>{item.prod}</div>
//                       </td>
//                       <td style={{ textAlign: 'right' }}>${item.rate}</td>
//                       <td style={{ textAlign: 'right' }}>{item.qty}</td>
//                       <td style={{ textAlign: 'right' }}>${item.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//               <table className="item_table itm_tab_padd totals-table" style={{ width: '300px' }}>
//                 <tbody>
//                   <tr>
//                     <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
//                       <strong>Sub Total:</strong>
//                       <span style={{ marginLeft: '15px' }}>${data.subTotal.toFixed(2)}</span>
//                     </td>
//                   </tr>
//                   {data.Discount > 0 && (
//                     <tr>
//                       <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
//                         <strong>
//                           Discount{data.discountType === 'percent' ? ` (${data.Discount}%)` : ''}:
//                         </strong>
//                         <span style={{ marginLeft: '15px' }}>${discountAmount}</span>
//                       </td>
//                     </tr>
//                   )}
//                   <tr>
//                     <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
//                       <strong>Tax ({data.TaxP}):</strong>
//                       <span style={{ marginLeft: '15px' }}>${data.TaxV.toFixed(2)}</span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td style={{ padding: '8px', borderBottom: '1px solid #B4B4D0' }}>
//                       <strong>Total:</strong>
//                       <span style={{ marginLeft: '15px' }}>${data.Estimatetotal.toFixed(2)}</span>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td style={{ padding: '8px', borderBottom: '3px solid #B4B4D0' }}>
//                       <strong>Deposit to Pay:</strong>
//                       <span style={{ marginLeft: '15px' }}>${data.Deposittopay.toFixed(2)}</span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

//   // useEffect(() => {
//   //   const fetchEstimate = async () => {
//   //     if (error) return;
//   //     try {
//   //       const response = await fetch(
//   //         `https://salesjet-10097049716.catalystappsail.com/esti?LeadACVLRecordID=${encodeURIComponent(decodedId)}`,
//   //         {
//   //           headers: {
//   //             Authorization: 'Bearer your_token_here', // Replace with actual token or logic to retrieve it
//   //           },
//   //         }
//   //       );

//   //       if (!response.ok) {
//   //         throw new Error(`HTTP error! Status: ${response.status}`);
//   //       }

//   //       const apiResponse = await response.json();
//   //       const bookingsData = apiResponse.data;

//   //       if (!bookingsData || !Array.isArray(bookingsData)) {
//   //         throw new Error('Invalid or missing data in API response');
//   //       }

//   //       if (decodedId) {
//   //         const booking = bookingsData.find(
//   //           (b) => String(b.LeadACVLRecordID).trim() === String(decodedId).trim()
//   //         );
//   //         setSelectedBooking(booking || null);
//   //       } else {
//   //         setSelectedBooking(bookingsData[0]);
//   //       }
//   //       setLoading(false);
//   //     } catch (err) {
//   //       setError('Failed to fetch estimate data: ' + err.message);
//   //       setLoading(false);
//   //     }
//   //   };

//   //   const fetchTermsHtml = async () => {
//   //     try {
//   //       const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
//   //       const data = await response.json();
//   //       const records = data.records || [];
//   //       const viewEstimateRaw = records[0]?.["ViewEstimate "] || '';
//   //       const decodedHtml = viewEstimateRaw.replace(/\\u003C/g, '<').replace(/\\u003E/g, '>');
//   //       setTermsHtml(decodedHtml);
//   //     } catch (err) {
//   //       console.error('Failed to fetch terms HTML:', err);
//   //     }
//   //   };

//   //   fetchEstimate();
//   //   fetchTermsHtml();
//   // }, [decodedId, error]);

// export default EstimatePage;


import React, { useState, useEffect } from 'react';
import './Emailestimate.css';
import imglogo from '../../Images/acvl logo white.png';
import { useParams, useLocation } from 'react-router-dom';

const EstimatePage = ({ LeadACVLRecordID }) => {
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [termsHtml, setTermsHtml] = useState('');
  const { id } = useParams();

  let recordId = LeadACVLRecordID;
  if (!recordId && id) {
    try {
      const potentialDecoded = atob(id);
      if (potentialDecoded && !isNaN(potentialDecoded)) {
        recordId = potentialDecoded;
      } else {
        recordId = id; 
      }
    } catch (e) {
      recordId = id;
    }
  }
  useEffect(() => {
    const fetchEstimate = async () => {
      if (!recordId) {
        setError('Missing LeadACVLRecordID.');
        setLoading(false);
        return;
      }
      try {
        console.log('Sending LeadACVLRecordID:', recordId);
        const response = await fetch(
          `https://salesjet-10097049716.catalystappsail.com/estiview?LeadACVLRecordID=${encodeURIComponent(recordId)}`
        );

        if (!response.ok) {
          if (response.status === 400) {
            throw new Error('LeadACVLRecordID is invalid.');
          } else {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
        }

        const apiResponse = await response.json();
        console.log('API Response:', apiResponse);
        const bookingsData = apiResponse.data;

        if (!bookingsData || !Array.isArray(bookingsData)) {
          throw new Error('Invalid or missing data in API response');
        }

        const booking = bookingsData.find(
          (b) => String(b.LeadACVLRecordID).trim() === String(recordId).trim()
        );
        setSelectedBooking(booking || null);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch estimate data: ' + err.message);
        setLoading(false);
      }
    };

    const fetchTermsHtml = async () => {
      try {
        const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
        const data = await response.json();
        const records = data.records || [];
        const viewEstimateRaw = records[0]?.["ViewEstimate "] || '';
        const decodedHtml = viewEstimateRaw.replace(/\\u003C/g, '<').replace(/\\u003E/g, '>');
        setTermsHtml(decodedHtml);
      } catch (err) {
        console.error('Failed to fetch terms HTML:', err);
      }
    };

    fetchEstimate();
    fetchTermsHtml();
  }, [recordId]);

  const parseItems = (itemsString) => {
    try {
      const cleanedString = (itemsString || '[]').replace(/[\[\]]/g, '');
      const itemsArray = cleanedString.split('},').map(item => {
        if (!item.endsWith('}')) item += '}';
        const descMatch = item.match(/desc=([^,}]*)/);
        const prodMatch = item.match(/prod=([^,}]*)/);
        const rateMatch = item.match(/rate=([^,}]*)/);
        const qtyMatch = item.match(/qty=([^,}]*)/);

        const desc = descMatch ? descMatch[1].trim() : 'Service Charge';
        const prod = prodMatch ? prodMatch[1].trim() : '';
        const rate = parseFloat(rateMatch ? rateMatch[1].trim() : '0.00');
        const qty = parseInt(qtyMatch ? qtyMatch[1].trim() : '1');
        const amount = (rate * qty).toFixed(2);

        return { desc, prod, rate: rate.toFixed(2), qty, amount };
      });

      return itemsArray;
    } catch (e) {
      return [{ desc: 'Service Charge', prod: '', rate: '0.00', qty: 1, amount: '0.00' }];
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!selectedBooking) return <div>No matching estimate found for ID: {recordId || 'N/A'}</div>;

  const data = {
    today: new Date(selectedBooking.CREATEDTIME).toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }),
    originCity: selectedBooking.FromAddress || 'N/A',
    originProvince: selectedBooking.FromAddress
      ? (selectedBooking.FromAddress.split(',')[2]?.trim() || 'N/A')
      : 'N/A',
    destinationCity: selectedBooking.ToAddress || 'N/A',
    destinationProvince: selectedBooking.ToAddress
      ? (selectedBooking.ToAddress.split(',')[2]?.trim() || 'N/A')
      : 'N/A',
    duration: 'N/A',
    customerName: selectedBooking.Customer_Name || 'N/A',
    SalesAgent: selectedBooking.Sales_Agent || 'N/A',
    MoveDate: selectedBooking.Move_Date || 'N/A',
    moveSize: selectedBooking.Move_Size || 'N/A',
    TaxV: parseFloat(selectedBooking.TAXValue) || 0.00,
    TaxP: selectedBooking.TaxPercentage || '0.00',
    Discount: parseFloat(selectedBooking.Discount) || 0.00,
    discountType: selectedBooking.DiscountType || 'percent',
    items: parseItems(selectedBooking.Items),
    Deposittopay: parseFloat(selectedBooking.Deposittopay) || 0.00,
    Estimatetotal: parseFloat(selectedBooking.Estimatetotal) || 0.00,
    subTotal: parseFloat(selectedBooking.Subtotal) || 0.00,
  };

  const discountAmount =
    data.discountType === 'percent'
      ? (data.subTotal * (data.Discount / 100)).toFixed(2)
      : data.Discount.toFixed(2);

  return (
    <div className="main-page">
      <div className="inner-page">
        <div className="header">
          <div>
            <div className="img-main-class" style={{ backgroundColor: '#f8f8f8' }}>
              <div className="img-cls"></div>
              <div className="img-cls">
                <img src={imglogo} alt="ACVL Logo" className="logo-cls" />
              </div>
            </div>
            <div className="light-gray-bar"></div>
            <div className="dark-gray-bg"></div>
            <div className="dark-gray-bar"></div>
            <div className="red-bar"></div>
            <div className="blue-bar"></div>
            <div className="white-stripe"></div>
            <div className="small-red-dot"></div>
            <div className="redd-bar"></div>
            <div className="header-padd">
              <table style={{ padding: '0px 20px' }}>
                <tr>
                  <th className="heading_h">Estimate</th>
                </tr>
                <tr>
                  <th className="date_h">
                    {data.today} / Est.No {recordId}
                  </th>
                </tr>
              </table>
            </div>
          </div>
          <div className="t_body" style={{ padding: '0px 20px' }}>
            <div className="t_body" style={{ width: '100%' }}>
              <table className="first_body cust_table">
                <tr>
                  <th>Origin Address</th>
                  <th>Destination Address</th>
                </tr>
                <tr>
                  <td>{data.originCity}</td>
                  <td>{data.destinationCity}</td>
                </tr>
                <tr>
                  <th>Customer Name</th>
                  <th>Sales Agent</th>
                  <th>Move Date</th>
                  <th>Move Size</th>
                </tr>
                <tr>
                  <td>{data.customerName}</td>
                  <td>{data.SalesAgent}</td>
                  <td>{data.MoveDate}</td>
                  <td>{data.moveSize}</td>
                </tr>
              </table>
            </div>
            <div>
              <table className="item_table itm_tab_padd" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'left' }}>S.No</th>
                    <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'left' }}>
                      Services / Products
                    </th>
                    <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>Price</th>
                    <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>
                      Quantity
                    </th>
                    <th style={{ borderBottom: '3px solid #B4B4D0', textAlign: 'right' }}>
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.items.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div>{item.desc}</div>
                        <div style={{ fontSize: '0.85em', color: '#555' }}>{item.prod}</div>
                      </td>
                      <td style={{ textAlign: 'right' }}>${item.rate}</td>
                      <td style={{ textAlign: 'right' }}>{item.qty}</td>
                      <td style={{ textAlign: 'right' }}>${item.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <table className="item_table itm_tab_padd totals-table" style={{ width: '300px' }}>
                <tbody>
                  <tr>
                    <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                      <strong>Sub Total:</strong>
                      <span style={{ marginLeft: '15px' }}>${data.subTotal.toFixed(2)}</span>
                    </td>
                  </tr>
                  {data.Discount > 0 && (
                    <tr>
                      <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                        <strong>
                          Discount{data.discountType === 'percent' ? ` (${data.Discount}%)` : ''}:
                        </strong>
                        <span style={{ marginLeft: '15px' }}>${discountAmount}</span>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                      <strong>Tax ({data.TaxP}):</strong>
                      <span style={{ marginLeft: '15px' }}>${data.TaxV.toFixed(2)}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', borderBottom: '1px solid #B4B4D0' }}>
                      <strong>Total:</strong>
                      <span style={{ marginLeft: '15px' }}>${data.Estimatetotal.toFixed(2)}</span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', borderBottom: '3px solid #B4B4D0' }}>
                      <strong>Deposit to Pay:</strong>
                      <span style={{ marginLeft: '15px' }}>${data.Deposittopay.toFixed(2)}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimatePage;